/**
 * Utility functions for managing GWP dismissed items in session storage
 */

const GWP_DISMISSED_STORAGE_KEY = 'gwp_dismissed_ids';

/**
 * Get dismissed GWP IDs from session storage
 * @returns {string[]} Array of dismissed GWP IDs
 */
export const getGwpDismissedIds = () => {
  try {
    const stored = sessionStorage.getItem(GWP_DISMISSED_STORAGE_KEY);
    return stored ? stored.split(',').filter(Boolean) : [];
  } catch (error) {
    console.error('Error reading from session storage:', error);
    return [];
  }
};

/**
 * Save dismissed GWP IDs to session storage
 * @param {string[]|number[]} ids - Array of GWP IDs to store
 */
export const setGwpDismissedIds = (ids) => {
  try {
    const uniqueIds = [...new Set(ids)].filter(Boolean);
    sessionStorage.setItem(GWP_DISMISSED_STORAGE_KEY, uniqueIds.join(','));
  } catch (error) {
    console.error('Error writing to session storage:', error);
  }
};
